(function () {
  const windowWidth = window.innerWidth;

  if (windowWidth > 1260) {

    console.log("desktop")


    /*
      sticky menu
    */

    const stickmenu = document.getElementById('sticky-menu');
    const buttonSearch = document.getElementById('buttonStickySearch');
    const buttonSearchClose = document.querySelector('.search-button-cancel');
    const searchForm = document.getElementById('searchForm');
    const sticky = stickmenu.offsetTop;

    window.onscroll = function () {
      myFunction()
    };

    function myFunction() {
      if (window.pageYOffset > sticky) {
        stickmenu.classList.add("sticky");
        productMenu.classList.add("menu-products--sticky")
      } else {
        stickmenu.classList.remove("sticky");
        productMenu.classList.remove("menu-products--sticky")
      }
    }

    buttonSearch.addEventListener('click', () => {
      if (getComputedStyle(searchForm).visibility == 'hidden') {
        searchForm.classList.add('header-main__search-form--active');
      } else {
        searchForm.classList.remove('header-main__search-form--active');
      }
    })

    if (buttonSearchClose) {
      buttonSearchClose.addEventListener('click', () => {
        searchForm.classList.remove('header-main__search-form--active')
      })
    }

    document.addEventListener("click", (evt) => {
      let targetElement = evt.target;

      do {
        if (targetElement == searchForm || targetElement.id == 'buttonStickySearch') {
          return;
        } else
          targetElement = targetElement.parentNode;

      } while (targetElement);
      (searchForm) ? searchForm.classList.remove('header-main__search-form--active'): '';

    });

    /*
      products button 
    */

    const productButton = document.getElementById('ProductButtonDesktop');
    const productMenu = document.getElementById('MenuProducts');

    document.addEventListener("click", (evt) => {
      let targetElement = evt.target;

      do {
        if (targetElement == productMenu || targetElement.id == 'ProductButtonDesktop') {
          return;
        } else
          targetElement = targetElement.parentNode;

      } while (targetElement);

      (productMenu) ? productMenu.classList.remove('menu-products--active'): '';
      (productButton) ? productButton.classList.remove('header-main__menu-link--active'): '';
    });

    productButton.addEventListener('mouseover', (evt) => {
      productMenu.classList.add('menu-products--active')
      productButton.classList.add('header-main__menu-link--active')
    })

    var isP = false;

    productButton.addEventListener('mouseleave', (evt) => {

      productMenu.addEventListener('mouseover', (evt) => {
        console.log(1)
        productMenu.classList.add('menu-products--active');
        productButton.classList.add('header-main__menu-link--active');
        isP = true;
        console.log(isP)
      })

      productMenu.addEventListener('mouseleave', (evt) => {
        console.log(2)
        productMenu.classList.remove('menu-products--active');
        productButton.classList.remove('header-main__menu-link--active');
        isP = false;
      })

      setTimeout(function () {
        if (!isP) {

          productMenu.classList.remove('menu-products--active')
          productButton.classList.remove('header-main__menu-link--active')

        }
      }, 500)
    })



    /*
      services button hover effect
    */

    const subheading = document.querySelectorAll('.subheading-menu');
    const menuSer = document.querySelectorAll('.header-main__menu-link--subheading');

    subheading.forEach((el, i) => {
      menuSer.forEach((el2, i2) => {
        if (i === i2) {
          el.addEventListener('mouseover', () => {
            el2.classList.add('header-main__menu-link--active');
          })

          el.addEventListener('mouseleave', () => {
            el2.classList.remove('header-main__menu-link--active');
          })
        } 
      })

      // const itemsNavs = document.querySelectorAll('.header-main__menu-item');

      // if (itemsNavs) {
      //   itemsNavs.forEach(el => {

      //     const men = el.querySelector('.subheading-menu');

      //     if (men) {

      //       el.addEventListener('mouseover', function () {
      //         men.classList.add('subheading-menu--active');
      //       })

      //       var isC = false;

      //       el.addEventListener('mouseleave', (evt) => {

      //         men.addEventListener('mouseover', (evt) => {
      //           men.classList.add('subheading-menu--active');
      //           isC = true;
      //           console.log('1') 
      //           console.log(isC)
      //         })

      //         men.addEventListener('mouseleave', (evt) => {
      //           men.classList.remove('subheading-menu--active');
      //           isC = false;
      //           console.log('2')
      //         })

      //         console.log(isC)

      //         setTimeout(function () {
      //           if (!isC) {
      //             men.classList.remove('subheading-menu--active')
      //           }
      //         }, 500)
      //       })
      //     }
      //   })
      // }


    })

  } else {

    console.log("mobile")


    /*
      sticky menu mobile
    */

    const stickyMobilemenu = document.getElementById('sticky-menu-mobile');
    if (stickyMobilemenu) {
      const sticky = stickyMobilemenu.offsetTop;

      window.onscroll = function () {
        myFunction()
      };

      function myFunction() {
        if (window.pageYOffset > sticky) {
          stickyMobilemenu.classList.add("sticky-mobile");
        } else {
          stickyMobilemenu.classList.remove("sticky-mobile");
        }
      }
    }


    /*
      toggle active menu
    */

    mobileMenu = () => {
      const mobileButton = document.getElementById('navMobileButton');
      const menu = document.getElementById('MenuMobile');
      const html = document.querySelector('html');
      if (mobileButton) {
        mobileButton.addEventListener('click', () => {
          menu.classList.toggle('menu-mobile--active');
          html.classList.toggle('overflow');
          mobileButton.classList.toggle('nav-mobile-button--active');
        })
      }
    }

    mobileMenu()

    console.log('cos')

    /*
      switching menu levels
    */

    const menu = document.querySelectorAll('[data-menu-item]');

    if (menu) {
      menu.forEach(element => {
        const submenuButton = element.querySelector('[data-submenu-button]');
        const submenu = element.querySelector('[data-submenu]');
        const submenuButtonBack = element.querySelector('[data-submenu-button-back]');

        submenuButton.addEventListener('click', () => {
          submenu.classList.add('nav-mobile__submenu--active');
          submenu.classList.add('nav-mobile__submenu--overflow');
          submenu.parentElement.parentElement.parentElement.classList.remove('nav-mobile__submenu--overflow');
        })
        submenuButtonBack.addEventListener('click', () => {
          submenu.classList.remove('nav-mobile__submenu--active');
          submenu.classList.remove('nav-mobile__submenu--overflow');
          submenu.parentElement.parentElement.parentElement.classList.add('nav-mobile__submenu--overflow');
        })
      })
    }
  }


  if (windowWidth < 768) {

    setTimeout(() => {
      const filterMenu = document.querySelectorAll('.menu-filter');

      if (filterMenu) {
        filterMenu.forEach(item => {
          const button = item.querySelector('.menu-filter-mobile');
          const menu = item.querySelector('.menu-filter-mobile-container');
          const items = item.querySelectorAll('.menu-filter-mobile-item');
          const itemActive = item.querySelector('.menu-filter-mobile-item--active');



          button.innerHTML = itemActive.innerHTML;

          button.addEventListener('click', () => {

            if (getComputedStyle(menu).visibility == 'hidden') {
              menu.classList.add('menu-filter-mobile-container--show');
              button.classList.add('menu-filter-mobile--active');
              menu.style.height = parseInt(items.length * 57) + 'px';
            } else {
              menu.classList.remove('menu-filter-mobile-container--show');
              button.classList.remove('menu-filter-mobile--active');
              menu.style.height = 0;
            }
          })

          items.forEach(itm => {
            itm.addEventListener('click', () => {
              const itemActive = item.querySelector('.menu-filter-mobile-item--active');
              button.innerHTML = itemActive.innerHTML;
              button.classList.remove('menu-filter-mobile--active')
              if (getComputedStyle(menu).visibility == 'hidden') {
                menu.classList.add('menu-filter-mobile-container--show');
              } else {
                menu.classList.remove('menu-filter-mobile-container--show');
                menu.style.height = 0;
              }
            })
          })
        })

        document.addEventListener("click", (evt) => {
          const button = document.querySelector('.menu-filter-mobile');
          const menu = document.querySelector('.menu-filter-mobile-container');
          let targetElement = evt.target;

          do {
            if (targetElement == button || targetElement.id == 'filter-items') {
              return;
            } else
              targetElement = targetElement.parentNode;

          } while (targetElement);
          if (menu) {
            menu.classList.remove('menu-filter-mobile-container--show');
            menu.style.height = 0;
          }
          if (button) {
            button.classList.remove('menu-filter-mobile--active')
          }
        });


      }
    }, 1000)

  }


})();